import { useMemo } from 'react'
import { useTranslation } from 'src/utils/i18n'
import StepLayout from './StepLayout'

const PhotosVideos = () => {
  const { t } = useTranslation('commonAndroid')
  const step = useMemo(
    () => [
      {
        title: <span>{t('Open Google Photos If there is no Google Photos on the device install first')}.</span>,
        img: [
          {
            src: '/images/login/backup4.jpg'
          }
        ]
      },
      {
        title: (
          <span>
            {t('Click the profile icon on the upper right corner sign in the Google account and click Turn on backup')}.
          </span>
        ),
        img: [
          {
            src: '/images/login/backup5.gif'
          }
        ]
      }
    ],
    [t]
  )

  return <StepLayout title={t('Back up photos  videos')} step={step} />
}

export default PhotosVideos
